import React, {useMemo} from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import {getAllItControls} from '../../../../../../../selectors/ISA315/selectors';

import BodySpecialAccordionHeaderColumn from '../BodySpecialAccordionHeaderColumn';
import {getRelatedItGcsList, getRelatedItGcCount, getRelatedITControls} from './commonCounters';
function ItProcessItGcCount({itProcessId, header, className, hasITControlTesting, onRender}) {
	const allItControls = useSelector(getAllItControls);
	const itProcess = useSelector((store) => store.bodiesSpecial.itProcesses?.byId[itProcessId]);

	const relatedITControls = useMemo(() => {
		return getRelatedITControls(allItControls, itProcess?.itControls, hasITControlTesting);
	}, [allItControls, itProcess]);

	let relatedItGcCount = 0;
	let relatedItGcsList;
	let textColor = 'var(--neutrals-1000)';

	if (relatedITControls) {
		relatedItGcsList = getRelatedItGcsList(relatedITControls);
		if (onRender) {
			textColor = onRender(relatedItGcsList);
		}

		relatedItGcCount = getRelatedItGcCount(relatedItGcsList);
	}

	return (
		<StyledItProcessItGcCount
			className={className}
			textColor={textColor}
			header={header}
			value={relatedItGcCount || '-'}
		/>
	);
}

ItProcessItGcCount.propTypes = {
	itProcessId: PropTypes.number.isRequired,
	itGcFilter: PropTypes.func,
	header: PropTypes.string.isRequired,
	className: PropTypes.string,
	hasITControlTesting: PropTypes.bool
};

export default ItProcessItGcCount;

const StyledItProcessItGcCount = styled(BodySpecialAccordionHeaderColumn)`
	width: var(--px-120);
	.body-special-accordion-header-column-value {
		color: ${(props) => props.textColor};
	}
`;
